import 'add-to-calendar-button';

function initAddToCalendarButton( button:HTMLElement ) {
	if( button ){
		// do we really need to do anything?
	}
}

export default {
	init: (el: HTMLElement) => {
		initAddToCalendarButton(el);
	}
}